import { createFileRoute } from '@tanstack/react-router'
import { questionSearchSchema } from '@/features/surveys/filter-questions/model/questionSearch'
import { SurveyDetailPage } from '@/pages/survey-detail/ui/SurveyDetailPage'

export const Route = createFileRoute('/surveys_/$surveyId')({
  validateSearch: questionSearchSchema,
  component: SurveyDetailPage,
})
